import { render, staticRenderFns } from "./demographics.vue?vue&type=template&id=6843f2ae&"
import script from "./demographics.vue?vue&type=script&lang=js&"
export * from "./demographics.vue?vue&type=script&lang=js&"
import style0 from "./demographics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports